import methods from './methods.js';
export default {
        'next': methods.trans('provider.next'),
        'previous':  methods.trans('provider.next'),
        'finish':  methods.trans('providerController.finish'),
        'basicinfo':  methods.trans('provider.basicinfo'),
        'vehicle':  methods.trans('provider.vehicle'),
        'bankinginfo':  methods.trans('provider.bankinginfo'),
        'docs':  methods.trans('provider.docs'),
        'signup':  methods.trans('providerController.provider_signup'),
};